import { render, staticRenderFns } from "./inventOrderGoodsAdd.vue?vue&type=template&id=6a115553"
import script from "./inventOrderGoodsAdd.vue?vue&type=script&lang=js"
export * from "./inventOrderGoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./inventOrderGoodsAdd.vue?vue&type=style&index=0&id=6a115553&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a115553')) {
      api.createRecord('6a115553', component.options)
    } else {
      api.reload('6a115553', component.options)
    }
    module.hot.accept("./inventOrderGoodsAdd.vue?vue&type=template&id=6a115553", function () {
      api.rerender('6a115553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/inventOrderGoodsAdd.vue"
export default component.exports